const MontantInput = function (props) {
	
	return <div className="question montant">
		<label htmlFor={props.name}>{props.children}</label>
		<div><input type="number"
			name={props.name}
			value={props.model}
			placeholder="Ex : 1000"
			onChange={(e)=> ( props.handler(parseInt(e.target.value) , props.modelName) )}
		/>€</div>
	</div>
};

export  {MontantInput};